import React, { useCallback, useState } from 'react';

import Button from '../../Button';

import { LinkWrap, Label, Input } from './Link.stc';

function Link(props) {
    const [expanded, setExpanded] = useState(false);

    const { config, onChange, currentState = {} } = props;
    const { className } = config;
    const toggleExpand = useCallback(() => setExpanded((state) => !state), []);
    const stopPropagation = useCallback((event) => event.stopPropagation(), []);
    const addLink = useCallback(
        (title, value, target) => {
            onChange('link', title, value, target);
            toggleExpand();
        },
        [onChange, toggleExpand]
    );
    const unlink = useCallback(() => onChange(), [onChange]);

    return (
        <div className={className}>
            <div onClick={toggleExpand} className="rdw-option-wrapper">
                <img src={config.link.icon} alt="" />
            </div>
            <div
                onClick={unlink}
                disabled={!currentState.link}
                className="rdw-option-wrapper"
            >
                <img src={config.unlink.icon} alt="" />
            </div>

            {expanded && (
                <LinkInputPopup
                    addLink={addLink}
                    onClose={toggleExpand}
                    onClick={stopPropagation}
                    {...currentState}
                />
            )}
        </div>
    );
}

export default Link;

function LinkInputPopup({ addLink, link = {}, onClose, selectionText }) {
    const linkTitle = link.title || selectionText || '';
    const [title, setTitle] = useState(linkTitle || '');
    const [target, setTarget] = useState(!!link.targetOption);
    const [value, setValue] = useState(link.target || '');
    // const [title, setTitle] = useState('');

    const handleAddLink = useCallback(() => {
        const targetOption = target ? '_blank' : '';
        addLink(title, value, targetOption);
    }, [target, addLink, title, value]);

    return (
        <LinkWrap>
            <Label>Link Text</Label>
            <Input
                type="text"
                value={title}
                style={{ marginBottom: 10 }}
                onChange={(e) => setTitle(e.target.value)}
            />
            <Label>Link</Label>
            <Input
                type="text"
                value={value}
                style={{ marginBottom: 10 }}
                onChange={(e) => setValue(e.target.value)}
            />
            <Label>
                <Input
                    type="checkbox"
                    checked={target}
                    onChange={(e) => setTarget(e.target.checked)}
                />{' '}
                Open in new tab
            </Label>
            <div style={{ marginTop: 10 }}>
                <Button size="sm" onClick={handleAddLink}>
                    Add Link
                </Button>
                <Button size="sm" type="link" onClick={onClose}>
                    Close
                </Button>
            </div>
        </LinkWrap>
    );
}
